import { render, staticRenderFns } from "./overPage.vue?vue&type=template&id=4cb41e0e"
import script from "./overPage.vue?vue&type=script&lang=js"
export * from "./overPage.vue?vue&type=script&lang=js"
import style0 from "./overPage.vue?vue&type=style&index=0&id=4cb41e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports